/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBellRinging2 = createReactComponent("outline", "bell-ringing-2", "IconBellRinging2", [["path", { "d": "M19.364 4.636a2 2 0 0 1 0 2.828a7 7 0 0 1 -1.414 7.072l-2.122 2.12a4 4 0 0 0 -.707 3.536l-11.313 -11.312a4 4 0 0 0 3.535 -.707l2.121 -2.123a7 7 0 0 1 7.072 -1.414a2 2 0 0 1 2.828 0z", "key": "svg-0" }], ["path", { "d": "M7.343 12.414l-.707 .707a3 3 0 0 0 4.243 4.243l.707 -.707", "key": "svg-1" }]]);

export { IconBellRinging2 as default };
//# sourceMappingURL=IconBellRinging2.mjs.map
